// src/admin/components/dashboard/SalesStatisticsChart.tsx
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface SalesChartData {
  name: string; // e.g., 'Jan', 'Feb'
  Revenue: number;
  Sales: number;
  Cancel: number;
}

interface SalesStatisticsChartProps {
  data: SalesChartData[];
}

const SalesStatisticsChart: React.FC<SalesStatisticsChartProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
        <XAxis dataKey="name" stroke="#888" />
        <YAxis stroke="#888" />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="Revenue" stroke="#F59E0B" activeDot={{ r: 8 }} />
        <Line type="monotone" dataKey="Sales" stroke="#82ca9d" />
        <Line type="monotone" dataKey="Cancel" stroke="#EF4444" />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default SalesStatisticsChart;